import { useState } from 'react';

export default function SubmitPayment() {
  const [ref, setRef] = useState('');

  return (
    <div>
      <h3>Submit Payment Reference</h3>
      <input placeholder="Payment Reference" onChange={e=>setRef(e.target.value)} /><br/>
      <button>Submit</button>
    </div>
  );
}
